














































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Modal from './Modal.vue'
import {Getter} from "vuex-class"
import client from '@/api/client'
import {sleep} from "@/utils/async"

declare const UIkit

@Component<FilterBarDownload>({
    components: { Modal }
})
export default class FilterBarDownload extends Vue {
    @Getter public $companyVars
    @Prop({ type: Boolean, default: true }) public icon!: boolean
    @Prop({ type: Function, default: () => 0 }) public downloadFile!: () => { data }
    @Prop({ type: Function, default: () => 0 }) public downloadFileAsync!: () => string
    @Prop({ type: String, default: 'report.pptx'}) public fileName!: string
    @Prop({ type: Boolean, default: false }) public disableDownload!: boolean
    public show = false
    public downloading = false

    public toggle() {
        this.$emit('toggle')
        this.show = !this.show
    }

    public close() {
        this.show = false
    }

    public async showDownloading() {
        if (this.disableDownload) {
            return
        }
        this.show = false
        this.downloading = true

        try {
            const statusUrl = await this.downloadFileAsync()
            let response
            do {
                await sleep(1000)
                const statusUrlResponse = await client.get(statusUrl, {baseURL: '/'})
                response = statusUrlResponse.data
            } while (!response)
            window.location = response
            this.downloading = false
            UIkit.notify('Your download has started!', { status: "success", timeout: 2000, pos: "top-right" })
            return

        } catch (error) {
            UIkit.notify('Something went wrong, please try again later', {
                status: 'danger'
            })
        }

        this.downloading = false
    }
}
